// LLM generated - Model Claude 4 Sonnet
import { SimpleGrid, Stack, Skeleton } from '@mantine/core';

type PaymentMethodsSkeletonProps = {
  isAeropayEnabled: boolean;
};

export function PaymentMethodsSkeleton({ isAeropayEnabled }: PaymentMethodsSkeletonProps) {
  return (
    <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={24}>
      {/* Skeleton for saved bank accounts section */}
      {isAeropayEnabled && (
        <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={16}>
          <Skeleton height={24} width="40%" />
          <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={8}>
            <Skeleton height={56} />
          </Stack>
        </Stack>
      )}

      {/* Skeleton for free payment types */}
      <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={16}>
        <Skeleton height={24} width="30%" />
        <SimpleGrid cols={2} /* eslint-disable-line local-rules/use-theme-tokens */ spacing={8}>
          <Skeleton height={96} />
          <Skeleton height={96} />
          <Skeleton height={96} />
          <Skeleton height={96} />
        </SimpleGrid>
      </Stack>

      {/* Skeleton for paid payment types */}
      <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={16}>
        <Skeleton height={24} width="35%" />
        <SimpleGrid cols={2} /* eslint-disable-line local-rules/use-theme-tokens */ spacing={8}>
          <Skeleton height={96} />
          <Skeleton height={96} />
        </SimpleGrid>
      </Stack>
    </Stack>
  );
}
